export default __webpack_public_path__ + "static/media/contactModel1.eef8433a.png";